import React from 'react'
import AntdTooltip from 'UI/Tooltip/Tooltip'
import styles from './Navigation.scss'

export const navigationTooltipProps = {
  classNames: {
    root: styles.expandButtonTooltipRoot,
    body: styles.expandButtonTooltipBody,
  },
  color: '#333434',
  placement: 'right' as const
}

export const NavigationTooltipWrapper = ({ isExpanded, children, title } : { isExpanded: boolean, children: React.ReactNode, title: string }) => {
  if (isExpanded) {
    return <>{children}</>
  }

  return (
    <AntdTooltip
      {...navigationTooltipProps}
      title={title}
    >
      {children}
    </AntdTooltip>
  )
}